import React, { useEffect, useState } from "react";
import FilteredDropDown from "./FilteredDropDown";
import { useSelector } from "react-redux";
import { RootState } from "../../types/redux";
import { SELECTION_TYPES } from "../../constants/enums";
import { DropdownType } from "../../types/fields";
import { CountryType } from "../../types/api/catalog";

const CountryPicker = ({ countries, ...props }: { countries: CountryType[] }) => {
  const recentOptions = useSelector((state: RootState) => state.userSelections[SELECTION_TYPES.COUNTRIES]);
  const [countryOptions, setCountryOptions] = useState<DropdownType[]>([]);

  useEffect(() => {
    if (!countries) return;

    let countryOptions = countries.map((c) => {
      return { label: c.name, value: c.iso };
    });

    setCountryOptions(countryOptions);
  }, [countries]);

  return (
    <FilteredDropDown
      fullOptions={countryOptions}
      recentOptions={recentOptions}
      {...props}
    />
  );
};

export default CountryPicker;